import React                                            from "react";
import {block}                                          from "../block";
import {UiSchemaEntry, DataCellType, ColumnCellType}    from "../@types";

const DataCell:React.FC<DataCellType> = ({data}) =>
    <span className={block.el('datacell-name')}>
        {
            typeof data === "string" || typeof data === "number" || data === null ? data :
            typeof data === "boolean" ? ( data ? '•' : '') :
            '🤷‍'
        }
    </span>
;

const ColumnCell:React.FC<ColumnCellType> = ({column: {name, title}}) =>
    <span className={block.el('columncell-name')}>
        {title || name}
    </span>
;

const text: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {text}
